import {
  ADD_SERVICE_TYPE_SUCCEEDED,
  CLEAR_SERVICE_TYPES_SUCCEEDED,
  GET_SERVICE_TYPE_FAILED,
  GET_SERVICE_TYPE_REQUERSTED,
  GET_SERVICE_TYPE_SUCCEEDED,
  UPDATE_SERVICE_TYPE_REQUERSTED,
  UPDATE_SERVICE_TYPE_SUCCEEDED,
} from './constants'

export const getServiceTypeRequested = (payload) => ({
  type: GET_SERVICE_TYPE_REQUERSTED,
  payload,
})
export const getServiceTypeSucceeded = (payload) => ({
  type: GET_SERVICE_TYPE_SUCCEEDED,
  payload,
})
export const getServiceTypeFailed = (payload) => ({
  type: GET_SERVICE_TYPE_FAILED,
  payload,
})

export const addServiceType = (payload) => ({
  type: ADD_SERVICE_TYPE_SUCCEEDED,
  payload,
})

export const updateServiceTypeRequested = () => ({
  type: UPDATE_SERVICE_TYPE_REQUERSTED,
})
export const updateServiceType = (payload) => ({
  type: UPDATE_SERVICE_TYPE_SUCCEEDED,
  payload,
})

export const clearServiceTypes = () => ({
  type: CLEAR_SERVICE_TYPES_SUCCEEDED,
})
